import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Logo from './Logo';

const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/50 backdrop-blur border-b">
      <div className="container flex items-center justify-between h-16 md:h-28">
        <Link to="/" className="flex items-center gap-3" aria-label="Sri GDM Home">
          <Logo />
          <span className="font-semibold text-lg">Sri GDM Interior Industries</span>
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-sm">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              isActive
                ? 'text-wood-dark border-b-2 border-wood-dark pb-1 font-semibold'
                : 'text-inherit'
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive
                ? 'text-wood-dark border-b-2 border-wood-dark pb-1 font-semibold'
                : 'text-inherit'
            }
          >
            About
          </NavLink>
          <NavLink
            to="/services"
            className={({ isActive }) =>
              isActive
                ? 'text-wood-dark border-b-2 border-wood-dark pb-1 font-semibold'
                : 'text-inherit'
            }
          >
            Services
          </NavLink>
          <NavLink
            to="/portfolio"
            className={({ isActive }) =>
              isActive
                ? 'text-wood-dark border-b-2 border-wood-dark pb-1 font-semibold'
                : 'text-inherit'
            }
          >
            Portfolio
          </NavLink>
          <NavLink
            to="/locations"
            className={({ isActive }) =>
              isActive
                ? 'text-wood-dark border-b-2 border-wood-dark pb-1 font-semibold'
                : 'text-inherit'
            }
          >
            Locations
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive
                ? 'text-wood-dark border-b-2 border-wood-dark pb-1 font-semibold'
                : 'text-inherit'
            }
          >
            Contact
          </NavLink>
        </nav>

        <div className="flex items-center">
          <button
            onClick={() => setOpen((o) => !o)}
            className="md:hidden p-2"
            aria-label="Toggle menu"
            aria-expanded={open}
            aria-controls="mobile-menu"
          >
            ☰
          </button>
        </div>
      </div>

      {open && (
        <div
          id="mobile-menu"
          className="md:hidden bg-white/90 border-t"
          role="navigation"
          aria-label="Mobile menu"
        >
          <div className="container flex flex-col py-4 gap-3">
            <NavLink
              to="/"
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'text-wood-dark font-semibold' : '')}
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'text-wood-dark font-semibold' : '')}
            >
              About
            </NavLink>
            <NavLink
              to="/services"
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'text-wood-dark font-semibold' : '')}
            >
              Services
            </NavLink>
            <NavLink
              to="/portfolio"
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'text-wood-dark font-semibold' : '')}
            >
              Portfolio
            </NavLink>
            <NavLink
              to="/locations"
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'text-wood-dark font-semibold' : '')}
            >
              Locations
            </NavLink>
            <NavLink
              to="/contact"
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'text-wood-dark font-semibold' : '')}
            >
              Contact
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
